// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2j70l","content":"GlobalSearch_content__3UYHH"};